import { Injectable } from '@angular/core';
import { ExactAlarmPermission, ExactAlarmPermissionPlugin } from 'src/plugins/exact-alarm-permisson/exact-alarm-permission.plugin';

@Injectable({
  providedIn: 'root'
})
export class ExactAlarmPermissionWrapper {

  async requestPermission(): Promise<ExactAlarmPermissionPlugin.RequestPermissionResponse> {
    const response = ExactAlarmPermission.requestPermission();
    return response;
  }

  async hasPermission(): Promise<ExactAlarmPermissionPlugin.HasPermissionResponse> {
    const response = ExactAlarmPermission.hasPermission();
    return response;
  }
}
